import { render, staticRenderFns } from "./ActiveBrandFilter.vue?vue&type=template&id=3bfac990&scoped=true"
import script from "./ActiveBrandFilter.vue?vue&type=script&lang=js"
export * from "./ActiveBrandFilter.vue?vue&type=script&lang=js"
import style0 from "./ActiveBrandFilter.vue?vue&type=style&index=0&id=3bfac990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfac990",
  null
  
)

export default component.exports